const CHUNK_LOAD_ERROR_PATTERNS: readonly RegExp[] = [
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i
];

/**
 * Determines whether a Router `NavigationError.error` value represents a browser-native
 * dynamic `import()` failure (typically caused by a lazy route chunk that no longer exists
 * on the server after a deployment), as opposed to an unrelated navigation error such as a
 * guard rejection.
 */
export function isChunkLoadError(error: unknown): boolean {
  const message = getErrorMessage(error);
  if (!message) {
    return false;
  }

  return CHUNK_LOAD_ERROR_PATTERNS.some(pattern => pattern.test(message));
}

function getErrorMessage(error: unknown): string | null {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  return null;
}
